<template>
	<div class="email" v-if="show">
		<div class="bg" @click.stop="close"></div>
		<div class="box">
			<svg t="1711362229289" class="close" viewBox="0 0 1024 1024" version="1.1" @click.stop="close">
				<path
					d="M517.12 944.64c-236.11392 0-427.52-191.40608-427.52-427.52 0-236.11392 191.40608-427.52 427.52-427.52 236.11392 0 427.52 191.40608 427.52 427.52C944.64 753.23392 753.23392 944.64 517.12 944.64zM517.12 143.04256c-206.59712 0-374.08256 167.48544-374.08256 374.08256S310.52288 891.20256 517.12 891.20256c206.60224 0 374.08256-167.48544 374.08256-374.08256S723.72224 143.04256 517.12 143.04256zM555.06432 517.26848l113.2032 113.2032c10.42432 10.42944 10.42432 27.3664 0 37.79584-10.43456 10.42944-27.35104 10.42944-37.79584 0l-113.2032-113.20832-113.99168 113.9712c-10.51648 10.5216-27.5712 10.5216-38.07744 0-10.51648-10.5216-10.51648-27.5712 0-38.07744l113.98144-113.98144L365.97248 403.75296c-10.43456-10.42944-10.43456-27.35104 0-37.78048 10.43456-10.43968 27.34592-10.43968 37.79072 0l113.21344 113.20832 114.82112-114.82112c10.51648-10.5216 27.5712-10.5216 38.08256 0 10.51648 10.51136 10.51648 27.5712 0 38.08256L555.06432 517.26848z"
					fill="#ffffff"
				></path>
			</svg>
			<h4>请输入您的邮箱</h4>
			<input type="text" v-model="email" @input="onInput" @blur="onBlur" />
			<div class="btn" @click="sub">确认</div>
		</div>
	</div>
</template>

<script>
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '@/config/config';
import verify from '@bluedot-tech/vue-ui/es/utils/verify';
import { Toast } from 'vant';
export default {
	name: 'email',
	components: {},
	props: {},
	data() {
		return {
			show: false,
			email: '',
			id: null
		};
	},
	created() {},
	mounted() {
		let email = this.$localStorage.getItem('email');
		if (email) this.email = email;
	},
	methods: {
		close() {
			this.show = false;
		},
		onInput() {
			this.$localStorage.setItem('email', this.email);
		},
		onBlur() {
			this.email = this.email.replace(/ /g, '');
			this.$localStorage.setItem('email', this.email);
		},
		sub() {
			if (!this.id) return;
			console.log(this.email);
			if (this.email?.length == 0) return Toast('请输入邮箱');
			let key = this.emailReg.test(this.email);
			console.log(key);

			if (key) {
				/* 通过校验 */
				this.show = false;
				let loading = Toast.loading({
					message: '提交中...',
					forbidClick: true,
					overlay: true
				});

				let crypt = new Crypt(config.crypto.publickey);
				this.$http
					.get(`/platform/product/download`, {
						params: {
							id: this.id,
							email: crypt.aes_encrypt(this.email),
							cryptKey: crypt.rsa_key_encrypt() //加密公钥传参
						}
					})
					.then((res) => {
						if (res.data.errcode) return Toast(res.data.errmsg);
						loading?.clear();

						Toast('发送成功');
					})
					.catch((err) => {
						loading?.clear();
					});
			} else {
				Toast('邮箱格式错误');
			}
		}
	}
};
</script>

<style lang="less" scoped>
.email {
	position: fixed;
	z-index: 1001;
	width: 828px;
	height: 100vh;
	left: 0;
	top: 0;

	.bg {
		background-color: rgba(0, 0, 0, 0.8);
		width: 100%;
		height: 100%;
	}

	.box {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: calc(100% - 94px - 94px);
		height: auto;
		padding: 60px 40px;
		background-color: #fff;
		// border-radius: @border-radius;
		border-radius: 30px;
		overflow: visible;

		h4 {
			font-size: 32px;
			color: #000000;
			line-height: 1;
			text-align: center;
			margin-bottom: 40px;
		}

		input {
			display: flex;
			align-items: center;
			width: 100%;
			height: 88px;
			padding: 0 33px;
			background: #f6f5f7;
			margin-bottom: 40px;
			font-size: 28px;
			color: #000000;
			line-height: 1;
		}

		.btn {
			width: 100%;
			height: 90px;
			background: @themeColor;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 34px;
			color: #ffffff;
			line-height: 1;
		}

		.close {
			position: absolute;
			right: 0;
			top: 0;
			transform: translate(20px, -80px);
			display: block;
			width: 48px;
			height: 48px;
			box-sizing: content-box;
			padding: 10px;
		}
	}
}
</style>
